import { Injectable } from '@angular/core';
import { Resolve, Router } from '@angular/router';
import { ChatService } from '../services/chat.service';
import { KeycloakService } from 'keycloak-angular';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';
import { of } from 'rxjs/internal/observable/of';

interface KeycloakTokenParsed {
  scope?: string;
  [key: string]: unknown;
}

@Injectable({
  providedIn: 'root'
})
export class NewThreadResolver implements Resolve<any> {
  constructor(
    private readonly chatService: ChatService,
    private readonly router: Router,
    private readonly keycloakService: KeycloakService
  ) { }

  async resolve() {
    // Check for required Keycloak permissions from token
    const tokenParsed = this.keycloakService.getKeycloakInstance().tokenParsed as KeycloakTokenParsed | undefined;

    // Check for permissions in token claims (scope is a space-separated string)
    const scope = tokenParsed?.scope ?? '';
    const permissions = scope.split(' ').filter((p: string) => p.trim() !== '');

    const requiredPermission = 'threads:view'; // Change this to your actual permission

    const hasAccess = permissions.includes(requiredPermission);

    if (!hasAccess) {
      // User doesn't have required permission, redirect to access-denied
      this.router.navigate(['/access-denied']);
      return of(null);
    }

    // User has permission, proceed with creating thread
    return this.chatService.createThread().pipe(
      tap(response => {
        // Navigate to the newly created thread
        this.router.navigate([`/main/chat-enhanced/${response.thread_id}`]);
      }),
      catchError(error => {
        // Error generating thread ID - handled silently (route will not navigate)
        return of(null);
      })
    ).subscribe();
  }
}